import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import Loader from '../components/Loader';

const MyListings = () => {
    const [listings, setListings] = useState([]);
    const [selectedListing, setSelectedListing] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [deleteListingId, setDeleteListingId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);

    useEffect(() => {
        const fetchListings = async () => {
            const hostData = getItemFromLocalStorage('hostProfile');
            let formData = new FormData();
            formData.append('token', hostData.host_access_token);

            let allListings = [];
            let page = 1;
            let totalPages = 1;

            setLoading(true);

            try {
                while (page <= totalPages) {
                    const url = `${params.baseURL}${params.endpoints.getMyListings}?page=${page}`;
                    const response = await axios({
                        method: 'post',
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        url,
                        data: formData
                    });

                    if (response?.data?.items && Array.isArray(response?.data?.items)) {
                        allListings = [...allListings, ...response?.data?.items];
                        totalPages = response?.data?._meta?.pageCount || 1;
                        page += 1;
                    } else {
                        break;
                    }
                }

                setListings(allListings);
            } catch (err) {
                setError(err);
                setLoading(false);
            } finally {
                setLoading(false);
            }
        };

        fetchListings();
    }, [page]);

    const handleDelete = async (listingId) => {
        try {
            const hostData = getItemFromLocalStorage('hostProfile');
            const formData = new FormData();
            formData.append('token', hostData.host_access_token);
            formData.append('listing_id', listingId);

            const response = await axios({
                method: 'post',
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                url: `${params.baseURL}${params.endpoints.deleteListing}`,
                data: formData
            });
            if (response.data.status == 'done') {
                toast.success('Listing deleted successfully!');
                setListings(listings.filter(l => l.stay_listing_id !== listingId));
                setShowModal(false);
                setConfirmDelete(false);
            } else {
                toast.error('Failed to delete listing.');
            }
        } catch (err) {
            console.error(err);
            toast.error('An error occurred while deleting.');
        }
    };

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return <p>Error loading listings: {error.message}</p>;
    }

    return (
        <div>
            <Helmet>
                <title>My Listing</title>
                <meta name="description" content="" />
            </Helmet>
            {listings.length > 0 && <div className='yl-header' style={{ padding: '0 12px' }}>
                <div>
                    <div className='img-title-box mb-0'>
                        <img src={'/assets/img/title/listing_title.svg'} className='img-fluid img-title' alt='' />
                    </div>
                </div>
                <a href='/create-listing/overview' style={{ marginTop: 'auto' }}>
                    <span className='yl-create-btn' style={{ background: 'transparent' }}>
                        <img src={'/assets/img/icons/add_listing_2.svg'} className='img-fluid' alt='' />
                    </span>
                </a>
            </div>}

            {listings.length > 0 ? (
                <div className='row'>
                    {listings.map((listing, index) => (
                        <div className='col-md-4 lb mb-3' key={listing.stay_listing_id}>
                            <div className='mylst-bx' onClick={() => {
                                setSelectedListing(listing);
                                setShowModal(true);
                            }}>
                                <div className='lcibox' style={{ marginBottom: '1rem' }}>
                                    <div className='mld-box'>
                                        <div className='position-relative'>
                                            <div className='mlcibox'>
                                                <div className='mlb-image'>
                                                    <img
                                                        className="mlimg"
                                                        src={listing.cover_photo || '/assets/img/default_listing.jpg'}
                                                        alt={listing.listing_title || 'Untitled Listing'}
                                                    />
                                                </div>
                                                <div className='mlsdb'>
                                                    <div className='mlsdb-box'>
                                                        <span
                                                            className={`ml-status ${listing.verification_status_id === 1
                                                                ? 'ls-active'
                                                                : listing.verification_status_id === 4
                                                                    ? 'ls-reject'
                                                                    : listing.verification_status_id === 3
                                                                        ? 'ls-progress'
                                                                        : 'bg-secondary'
                                                                }`}
                                                        ></span>
                                                        <span className='ml-stxt'>{listing.verification_status_text}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/*<div className='lsvrbox'>
                                                <div className='button-container'>
                                                    {listing.vibe_unlock_status === 1 && (
                                                        <a
                                                            href={`/videos/${listing.stay_listing_id}`}
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            <img src={'/assets/img/icons/vibe_btn.png'} className='img-fluid' />
                                                        </a>
                                                    )}
                                                    <a
                                                        href={`/ratings/${listing.stay_listing_id}`}
                                                        onClick={(e) => e.stopPropagation()}
                                                        className="lrtng-box"
                                                    >
                                                        {Array.from({ length: 5 }).map((_, index) => {
                                                            const rating = listing.overall_rating;
                                                            const fullStars = Math.floor(rating);
                                                            const hasHalfStar = rating - fullStars >= 0.25 && rating - fullStars < 0.75;

                                                            if (index < fullStars) {
                                                                return <i key={index} className="fas fa-star"></i>;
                                                            } else if (index === fullStars && hasHalfStar) {
                                                                return <i key={index} className="fas fa-star-half-alt"></i>;
                                                            } else {
                                                                return <i key={index} className="far fa-star"></i>;
                                                            }
                                                        })}
                                                    </a>
                                                    
                                                </div>
                                            </div>*/}
                                        </div>
                                        <div className='pltxt-box'>
                                            <div className='cat-pointer mb-0'>
                                                <img src={listing.property_title_icon_image} alt='' className='img-fluid pointer-icon' style={{ boxShadow: 'none' }} />
                                                <div className='wspl-ta-section'>
                                                    <span className='wspl-title-box'>{listing.listing_title || 'Unknown Title'}</span>
                                                    <span className='wspl-add-box'>{listing.property_address}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="d-flex flex-column justify-content-center align-items-center vh-100">
                    <i className="bi bi-card-list text-secondary" style={{ fontSize: "3.5rem" }}></i>
                    <h4 className="mt-3">No Listings Found</h4>
                    <p className="text-muted">Looks like you don’t have any listings yet.</p>
                    <a href='/create-listing/overview' className="btn btn-primary mt-3">
                        <i className="bi bi-plus-circle me-2"></i> Add New Listing
                    </a>
                </div>


            )}

            {showModal && (
                <div className="modal-overlay">
                    <div className="modal-content" style={{ maxWidth: '450px', height: '510px', border: '4px solid #ccc' }}>
                        <div className="listing-popup-header">
                            <div className="euc-close" style={{ cursor: 'pointer' }} onClick={() => setShowModal(false)}>
                                <img src={'/assets/img/icons/popup_close.png'} className="img-fluid" alt="" style={{ width: '30px' }} />
                            </div>
                        </div>
                        <div className='listing-popup'>
                            <img src={selectedListing.cover_photo ? selectedListing.cover_photo : '/assets/img/default_listing.jpg'} className='img-fluid lpimg' alt='' />
                            <div className='cat-pointer'>
                                <img src={selectedListing.property_title_icon_image} alt="Profile" className="pointer-icon" />
                                <div className='wspl-ta-section' style={{ fontSize: '14px' }}>
                                    <span className='wspl-title-box'>{selectedListing.listing_title || 'Unknown Title'}</span>
                                    <span className='wspl-add-box'>{selectedListing.property_address}</span>
                                </div>
                            </div>
                        </div>
                        <div className='listing-popup-footer'>
                            <button className='btn btn-black' onClick={() => window.location.href = `/create-listing/${selectedListing.stay_listing_id}`}>
                                Edit Listing
                            </button>
                            <button className='btn btn-blank' style={{ height: '50px' }} onClick={() => {
                                setConfirmDelete(true);
                                setDeleteListingId(selectedListing.stay_listing_id);
                            }}>
                                Remove Listing
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {confirmDelete && (
                <div className="modal-overlay">
                    <div className="modal-content" style={{ maxWidth: '450px', height: '510px', border: '4px solid #ccc' }}>
                        <div className='listing-popup'>
                            <img src={'/assets/img/icons/popup_close.png'} className="img-fluid mb-4" alt="" style={{ height: '230px' }} />
                            <h4>Remove this listing?</h4>
                            <p>You can’t view or edit this listing. Your data will be deleted within 30 days.</p>
                        </div>
                        <div className='listing-popup-footer'>
                            <button className='btn btn-black' onClick={() => handleDelete(deleteListingId)}>
                                Yes Remove
                            </button>
                            <button className='btn btn-blank' style={{ height: '50px' }} onClick={() => setConfirmDelete(false)} >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default MyListings;
